import { startCase, toLower } from 'lodash-es';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';

export function getTitleCase(string: string) {
  return startCase(toLower(string));
}

export const getFullName = (creditReport: CreditReportType) => {
  const {
    First: firstName,
    Middle: middleName,
    Surname: lastName,
    // Spanish surname, hyphenated name, etc.
    SecondSurname: secondSurname,
    // Junior, III, etc.
    Gen: gen,
  } = creditReport.fullCreditProfile?.ConsumerIdentity?.[0]?.Name || {};

  return firstName && lastName
    ? [
        getTitleCase(firstName),
        getTitleCase(middleName || ''),
        getTitleCase(lastName),
        getTitleCase(secondSurname || ''),
        getTitleCase(gen || ''),
      ]
        .filter((name) => name)
        .join(' ')
    : 'name unavailable';
};
